import { createContext } from "react";

export const TestMethodContext = createContext({
  testMethod: {},
  onChange: () => {},
});
